import {DesktopTicketsPicker} from './desktop-tickets-picker'

export default DesktopTicketsPicker
